import { Component, OnInit, Inject, HostListener, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '../../../../translate/translate.service';
import { InventoryComponent } from '../../pages/inventory.component';
import { InventoryService } from '../../inventory-service.service';
import {
  SystemsInInventoryViewModel,
  SystemComponentViewModel,
  ComponentHistoryViewModel} from '../../inventory-models';
import { JobSite, Customer, Tuple, SelectionLists } from '../../../../entities';
import { Observable } from 'rxjs/Observable';
import { MeasurementPonitsService } from '../../../../modules/measurement-points-admin/services/measurement-points-service';
import { MeasurementToolsViewModel } from '../../../../modules/measurement-points-admin/model/measurement-points.model';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ActionPopupComponent } from '../../../../modules/action/action-popup/action-popup-inInventory/action-popup.component';
import { Subscription } from 'rxjs/Subscription';
import { AppService } from '../../../../app.service';
import { AddThermographyInspectionDetailsCommentComponent } from '../../../Thermography/create-new-thermography-inspection/add-temp-inspection-details-comment/add-thermography-inspection-details-comment';
import { MultiplePhotoUploadComponent } from '../../../interpretation/components/multiple-photo-upload/multiple-photo-upload.component';
import { PopupEndPoint } from '../../../inspection/models/create-inspection.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CostEditPopupComponent } from '../cost-edit-popup/cost-edit-popup.component';
import { InterpretationService } from '../../../interpretation/interpretation.service';
import { TrackFrameConfigurationComponent } from '../../../manage-equipment/components/track-frame-configuration/track-frame-configuration.component';
import { UserService } from '../../../../shared/services/user.service';
import { toolType, toolTypePassFail, toolTypeYesNo } from '../../../../shared/enums/allEnums';
import { WSREActionHistoryVM } from '../../../../modules/wsre/models/wsre.model';
import { WsreService } from '../../../../modules/wsre/wsre.service';
import { PageEvent } from '@angular/material/paginator';
import { CustomerServiceIdentity } from '../../../../modules/IDENTITY_WEB/services/customer.service';
import { ChangeComponentComponent } from '../../../../modules/manage-equipment/components/change-component/change-component.component';

@Component({
  selector: 'app-system-inventory-management',
  templateUrl: './system-inventory-management.component.html',
  styleUrls: ['./system-inventory-management.component.scss']
})
export class SystemInventoryManagementComponent implements OnInit {
  selectedTab = 0;
  isLoading = true;
  componentList: SystemComponentViewModel[] = [];

  componentHistories: ComponentHistoryViewModel[] = [];
  trackTools: MeasurementToolsViewModel[] = [];

  system: SystemsInInventoryViewModel;

  public customerList: Customer[] = [];
  public jobsiteList: JobSite[] = [];
  public availableJobsites: JobSite[] = [];

  public selectedCustomer: Customer;
  public selectedJobsite: JobSite;
  translateSubscription: Subscription;
  luUCInventoryStatusModel: Number = 1;
  inventorySide: Number = 1;
  updated = false;
  saving = false;
  flagSideDropDown :boolean =false;
  SystemTypeName: string;
  _dropDownLists: SelectionLists = new SelectionLists();
  _sideList = [
    { Id: 0, name: "None" },
    { Id: 1, name: "Left" },
    { Id: 2, name: "Right" }
  ];
  
  private _userLanguage = 'english';
  selectedType: number;
  selectedSide: number;
  imagesComingFrom = PopupEndPoint.InventoryComponent;
  image: string;
  serialNumber: string = null;
  oldserialNumber: string = null;
  editableSerialNo: boolean = true;
  sideUpdated: boolean = false;
  public editableSystemBudgetLife: boolean = false;
  public editableSysBudgetDistance: boolean = false;
  isAdministrator: boolean = false;
  toolType = toolType;
  toolYesNo = toolTypeYesNo;
  toolPassFail = toolTypePassFail;
  screenId: number;
  auditTrailHistory: WSREActionHistoryVM[] = [];
  loadSize: number = 10;
  loadingPage: number = 1;
  auditTrailTotalRecords: number = 0;
  systemId: number;
  isBasicUser: number = 1;
  constructor(
    private _translate: TranslateService,
    public dialogRef: MatDialogRef<InventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private inventoryService: InventoryService,
    private measurementService: MeasurementPonitsService,
    private notification: NotificationsService,
    private loadingService: LoadingService,
    private _dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private _appService: AppService,
    private _interp: InterpretationService,
    private _userService: UserService,
    private _wsreService: WsreService,
    private _customerServiceIdentity: CustomerServiceIdentity
  ) { }

  ngOnInit() {
    this.system = this.data.system;
    this.systemId = this.data.system.SystemId;
    this.screenId = this.system.SystemTypeName === "Chain" ? 4 : this.system.SystemTypeName === "Frame" ? 5 : 6;
    this.getSystemLife();
    this.getSystemDOC();
    this.loadUserJobRoles();
    this._customerServiceIdentity.CheckUCUserType().subscribe(result => {
      this.isBasicUser = result;
    });
   // this.selectedSide = this.data.system.SystemType;
    this.inventorySide = this.data.system.Side =="Left"?1:2;
    this.flagSideDropDown = this.data.system.SystemTypeName =="Frame"? true:false;
    this.jobsiteList = this.data.jobsites;
    this.customerList = this.data.customers;
    this.selectedCustomer = this.data.customer;
    this.SystemTypeName = this.data.system.SystemTypeName
    this.luUCInventoryStatusModel = this.data.system.InventoryStatusId
    this.getLUUCInventoryStatus(this.SystemTypeName);
    this.loadHistoriesAndInfo();
    if (this.selectedCustomer === undefined || this.selectedCustomer == null) {
      this.selectedCustomer = this.customerList.find(
        c => c.Id === this.system.CustomerId
      );
      this.availableJobsites = this.jobsiteList.filter(
        j => j.CustomerId === this.system.CustomerId
      );
    } else {
      this.availableJobsites = this.jobsiteList.filter(
        j => j.CustomerId === this.system.CustomerId
      );
      }
    this.selectedJobsite = this.jobsiteList.find(j => j.Id === this.system.JobSiteId);
    this.measurementService.getMeasurementTools().subscribe(r => {
      this.trackTools = r;
    });

    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
    
  }

  onTabChange(event: any) {
    this.selectedTab = event.index;
    if (event.index === 1) {
      //this.loadActionHistory(this.loadingPage, this.loadSize);
    }
  }

  //code to edit and save the Serial Number

  onSaveSerialNumber(system: any) {
    var model = {}
    model = { serialNumber: this.serialNumber, moduleSubAuto: system.ModuleSubAuto };
    this.inventoryService.UpdateInventorySerial(model).subscribe(res => {
      if (res) {
        this.editableSerialNo = true;
        this.notification.success("Serial number updated succesfully.")
        this.editableSerialNo = true;
        this.system.SerialNumber = this.serialNumber;
      }else{
        this.notification.error("Failed to update the Serial Number.")
      }
    })
  }
  onCancelSerialNumber(type: number) {
    this.serialNumber = this.oldserialNumber;
    this.editableSerialNo = true;
    this.ref.detectChanges();


  }
  editSerialNumber(system: any) {
    this.serialNumber = system.SerialNumber;
    this.oldserialNumber = system.SerialNumber;
    this.editableSerialNo = false;


  }
  //code end
  updateUserLang(lang: string) {
    this._userLanguage = lang;
    this.ref.detectChanges();
  }
  FrameCost:number=0;
  FrameRepairCost:number=0;
  loadHistoriesAndInfo() {
    this.isLoading = true;
    const info = this.inventoryService.getSystemComponentsInfo(
      this.system.SystemId
    );
    const history = this.inventoryService.getSystemAllActionHistories(
      this.system.SystemId
    );

    Observable.forkJoin([info, history]).subscribe(results => {
      this.isLoading = false;

      this.componentList = results[0];
      this.TotalInitalCost=0;
      this.TotalRepairCost=0;
      this.FrameCost=this.componentList[0].FrameCost
      this.FrameRepairCost=this.componentList[0].FrameRepairCost

      this.componentList.forEach(x=> {
        this.TotalInitalCost= this.TotalInitalCost + x.InititalCost,
        this.TotalRepairCost= this.TotalRepairCost+ x.TotalCost
      })
      this.componentHistories = results[1];
      //console.log(this.componentList);
    });
  }
TotalInitalCost:number=0;
TotalRepairCost:number=0;
  translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }

  onNoClick() {
    this.dialogRef.close(this.updated);
    
  }

  
  onNoClickPopup() {
    this.dialogRef.close();
    
  }
  @HostListener('window:keyup.esc')
  onKeyUp() {
    this.dialogRef.close(false);
  }

  isRopeShovel(): boolean {
    if (
      this.system.TypeFamilyName === 'Rope Shovel' ||
      this.system.TypeFamilyName === 'Mining Shovel'
    ) {
      return true;
    }
    return false;
  }

  saveNote() {
    this.loadingService.startLoading();
    this.inventoryService
      .updateSystemNotes(this.system.SystemId, this.system.SystemNote, this.screenId)
      .subscribe(r => {
        this.popupNotification(r);
      });
  }

  changeTool(tool: MeasurementToolsViewModel, component: SystemComponentViewModel) {
    component.ToolName = tool.ToolName;
    component.ToolId = tool.ToolId;
    component.ScreenId = this.screenId;
    //this.loadingService.startLoading();
    //this.inventoryService
    //  .updateSystemInInventoryInfo(component)
    //  .subscribe(r => {
    //    this.popupNotification(r);
    //    });

    this.changeToolHelperMethod(component);
  }

  changeToolHelperMethod(component: SystemComponentViewModel) {
    this.loadingService.startLoading();
    this.inventoryService
      .getWornPercentageCalculationMethod(
        component.CompartId,
        component.ToolId,
        component.MeasurementPoints,
        component.LastestInpsectionId,
        component.EqunitId
      )
      .subscribe(r => {
        component.WornPercentage = r.m_Item1;
        component.Condition = r.m_Item2;
        this.inventoryService
          .updateSystemInInventoryInfo(component)
          .subscribe(res => {
            this.updated = true;
            this.popupNotification(res);
          });
        this.loadingService.finishedLoading();
      });
  }


  BudgetChanged(event, component: SystemComponentViewModel) {
    component.Budget = event;
    this.loadingService.startLoading();
    component.Budget = event;
    component.ScreenId = this.screenId;
    this.inventoryService
      .updateSystemInInventoryInfo(component)
      .subscribe(res => {
        this.updated = true;
        this.popupNotification(res);
      });
    this.loadingService.finishedLoading();
  }
  DistanceBudgetChanged(event, component: SystemComponentViewModel) {
    component.DistanceBudget = event;
    this.loadingService.startLoading();
    component.Budget = event;
    component.ScreenId = this.screenId;
    this.inventoryService
      .updateSystemInInventoryInfo(component)
      .subscribe(res => {
        this.updated = true;
        this.popupNotification(res);
      });
    this.loadingService.finishedLoading();
  }
  CMUChanged(event, component: SystemComponentViewModel) {
    this.loadingService.startLoading();
    component.CMU = event;
    component.ScreenId = this.screenId;
    this.inventoryService
      .updateSystemInInventoryInfo(component)
      .subscribe(res => {
        this.updated = true;
        this.popupNotification(res);
      });
    this.loadingService.finishedLoading();
  }
  DOCChanged(event, component: SystemComponentViewModel) {
    this.loadingService.startLoading();
    component.DOC = event;
    component.ScreenId = this.screenId;
    this.inventoryService
      .updateSystemInInventoryInfo(component)
      .subscribe(res => {
        this.updated = true;
        this.popupNotification(res);
      });
    this.loadingService.finishedLoading();
  }
  measurementChanged(event, component: SystemComponentViewModel) {
    component.MeasurementPoints = event;
    component.ScreenId = this.screenId;
    this.loadingService.startLoading();
    this.inventoryService
      .getWornPercentageCalculationMethod(
        component.CompartId,
        component.ToolId,
        event,
        component.LastestInpsectionId,
        component.EqunitId
      )
      .subscribe(r => {
        component.WornPercentage = r.m_Item1;
        component.Condition = r.m_Item2;
        this.inventoryService
          .updateSystemInInventoryInfo(component)
          .subscribe(res => {
            this.updated = true;
            this.popupNotification(res);
          });
        this.loadingService.finishedLoading();
      });
  }

  changeEval(newEval: string, component: SystemComponentViewModel) {
    component.Condition = newEval;
    component.ScreenId = this.screenId;
    this.loadingService.startLoading();
    this.inventoryService
      .updateSystemInInventoryInfo(component)
      .subscribe(r => {
        this.updated = true;
        this.popupNotification(r);
      });
  }

  onToolOptionSelect(component: SystemComponentViewModel, value: number) {
    component.MeasurementPoints = value;
   //component.ScreenId = this.screenId;
    this.loadingService.startLoading();
    this.inventoryService
      .updateSystemInInventoryInfo(component)
      .subscribe(r => {
        this.updated = true;
        this.popupNotification(r);
      });
  }

  recordAction(component: SystemComponentViewModel) {
    const dialogRef = this._dialog.open(ActionPopupComponent, {
      panelClass: 'removeModalOverflowTest',
      data: {
        component: component,
        customer: this.selectedCustomer,
        modelId: this.system.TypeFamilyId,
        systemId: this.system.SystemId,
        make: this.system.MakeDesc,
        makeId: this.system.MakeId,
        CMU:this.system.AverageCMU
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
        this.loadHistoriesAndInfo();
        this.updated = true;
      }
    });
  }

  costAction(component: SystemComponentViewModel) {
    const dialogRef = this._dialog.open(CostEditPopupComponent, {
      panelClass: 'removeModalOverflowTest',
      data: {
        component: component,
        screenId: this.screenId
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
        this.loadHistoriesAndInfo();
        this.updated = true;
      }
    });
  }

  jobsiteChanged(event) {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
  }

  customerChanged(event) {
    this.selectedCustomer = event.value;
    if (!this.selectedCustomer) {
      return;
    }
    this.availableJobsites = this.jobsiteList.filter(
      m => m.CustomerId === this.selectedCustomer.Id
    );
    this.selectedJobsite = null;
  }

  jobsiteSelected() {
    return this.selectedJobsite !== undefined && this.selectedJobsite != null;
  }



  changeluUCInventoryStatusModel(event: any) {
    if (event.value != "") {
      this.updateLUUCInventoryStatus(this.data.system.ModuleSubAuto, event.value)
    }
  }

  changeSideInventory(event: any) {
    if (event.value != "") {
      this.updateSideStatus(this.data.system.ModuleSubAuto, event.value)
    }
    
  }

  checkInventoryStatus(statusId: number) {
    if (this.luUCInventoryStatusModel == 6 && statusId != 6)
      return true;
    else if (statusId == 6) // 6 = On Machine - select * from LU_UCInventory_Status
      return true;
    else
      return false;
  }

  updateLUUCInventoryStatus(ModuleSubAuto: number, Id: number) {
    this.loadingService.startLoading();
    this.inventoryService
      .updateLUUCInventoryStatus(ModuleSubAuto, Id, this.screenId)
      .subscribe(r => {
        this.popupNotification(r);
      });
  }
  updateSideStatus(ModuleSubAuto: number, Id: number) {
   
    this.loadingService.startLoading();
    this.inventoryService
      .updateSideStatus(ModuleSubAuto, Id)
      .subscribe(r => {
        
        this.popupNotification(r);
        this.updated= true;
       
      });
      //this.dialogRef.close(true); 
  }

  
  getLUUCInventoryStatus(SystemTypeName: string) {
    this._appService.getLUUCInventoryStatusDropdownList(SystemTypeName).subscribe(
      result => {
        this._dropDownLists.luUCIInventoryStatusModel = result;
      },
      error => {
        console.error(error);
      },
    );
  }
  reloacateSystem() {
    this.loadingService.startLoading();
    this.saving = true;
    this.inventoryService
      .relocateSystemJobsite(this.system.SystemId, this.selectedJobsite.Id)
      .subscribe((r:any) => {
        this.updated = true;
        this.popupNotification(r);
        this.saving = false;
      });
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }

  private popupNotification(result: Tuple) {
    this.loadingService.finishedLoading();
    if (result.m_Item1) {
      this.notification.success(result.m_Item2);

    } else {
      this.notification.error(result.m_Item2);
    }
  }
  showPosition(Pos: number, CompartTypeId: number): any {
    if (CompartTypeId === 233) // Idler
    {
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
    }
    // Carrier roller
    else if (CompartTypeId === 234 && Pos === 1) {
      return 'Front';
    }
    // Link, Bushing, Shoe, Sprocket

    else if (CompartTypeId == 230 || CompartTypeId == 231 || CompartTypeId == 232 || CompartTypeId == 236 || CompartTypeId == 237 || CompartTypeId == 240 || Pos == undefined) {
      return '';
    }
    else if (CompartTypeId == 446) {
      return 'Rear'
    }

    else {
      return Pos.toString();
    }
  }
  saveChanges() { }

  AddComment(component: SystemComponentViewModel) {
    const newInspectionDetailCommentDialog = this._dialog.open(AddThermographyInspectionDetailsCommentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: component.EqunitId,
        inspectionDetailID: 0,
        Inspcomment: component.Comment,
        isedit: true,
        isWsre: true,
        component: component,
        screenId: this.screenId
      },
      minWidth: 500
    });

    newInspectionDetailCommentDialog.afterClosed().subscribe(result => {

      if (result) {
        //this.LoadFrameComponentsLeftAndRight();
        
      }
    });
  }

  getCommentTitle(comment: string) {
    var _msg = "Add/View Comment";
    if (comment != null) {
      if (comment.length > 0) {
        if (comment.length > 30)
          _msg = comment.substring(0, 30) + "...";
        else
          _msg = comment;
      }
    }
    return _msg;
  }
  loadPhoto(component: SystemComponentViewModel) {
    ////this._interp.getComponentPhotoList(component.InspectionDetailId, this.inspectionId).subscribe(res => {
    ////  if (res.photo1 != null) {
    ////    component.PhotoThumbnail = res.photo1;
    ////    //this.updateComment = res.m_Item2;
    ////  } else {
    ////    component.PhotoThumbnail = '';

    ////  }
    ////})
    //////component.Comment = this.updateComment;
    //this.popupNotification(r);
    component.ImagesCount = 1;
  }
  viewComponentPhoto(component: SystemComponentViewModel) {
    //console.log("id__1",photoId)
    //const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    const viewPhotoModalRef = this._dialog.open(MultiplePhotoUploadComponent, {
      width: '800px',

      data: {
        comingFrom: this.imagesComingFrom,
        componentDetailId: component.ComponentInInventoryDetailId,
        ScreenId: this.screenId
        //photoId: photoId,
        //inspectionDetailId: inspectionDetailId
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(result => {
       if (result && result.Close) {
          if (result.ImageCount <= 0) {
              component.ImagesCount = 0;
          }
        }
       //this.loadPhoto(component)//this.loadSystem();
    });
  }

  editSysBudgetLife(type: number) {
    this.editableSystemBudgetLife = true;
  }
  onSaveSysBudgetLife(Id: number, BudgetLife: number) {
    this.editableSystemBudgetLife = false;
    this.UpdateBudgetLife(Id, BudgetLife);
  }
  onCancelSysBudgetLife() {
    this.editableSystemBudgetLife = false;
  }
  editSysBudgetDistance(type: number) {
    this.editableSysBudgetDistance = true;
  }
  onSaveSysBudgetDistance(Id: number, BudgetDistance: number) {
    this.editableSysBudgetDistance = false;
    this.UpdateBudgetDistance(Id, BudgetDistance);
  }
  onCancelSysBudgetDistance() {
    this.editableSysBudgetDistance = false;
  }
  editableFrameCost:boolean=false;
  editableFrameRepairCost:boolean=false;
  onSaveSystemFrameCost(Id: number, FrameCost: number) {
    this.editableFrameCost = false;
    this.UpdateFrame(Id, this.FrameCost);
  }

  editSysFrameCost(type: number) {
    this.editableFrameCost = true;
  }
  onCancelFrameCost() {
    this.editableFrameCost = false;
  }

  onSaveSystemFrameRepairCost(Id: number, FrameCost: number) {
    this.editableFrameRepairCost = false;
    this.UpdateFrameRepair(Id, this.FrameRepairCost);
  }

  editSysFrameRepairCost(type: number) {
    this.editableFrameRepairCost = true;
  }
  onCancelFrameRepairCost() {
    this.editableFrameRepairCost = false;
  }

  UpdateFrame(Id: number, FCost: number) {
    this._interp.UpdateFrameCost(Id, FCost, this.screenId).subscribe(res => {
      if (res) {
        this.notification.success("Frame cost updated successfully")
      } else {
        this.notification.error("Error while updating Frame cost, Please contact Tracktreads Support")
      }
    })
  }

  UpdateFrameRepair(Id: number, FCost: number) {
    this._interp.UpdateFrameRepairCost(Id, FCost, this.screenId).subscribe(res => {
      if (res) {
        this.notification.success("Frame cost updated successfully")
      } else {
        this.notification.error("Error while updating Frame cost, Please contact Tracktreads Support")
      }
    })
  }

  UpdateBudgetLife(Id: number, BudgetLife: number) {
    this._interp.UpdateBudgetLife(Id, BudgetLife, this.screenId).subscribe(res => {
      if (res) {
        this.notification.success("Budget Life updated successfully")
      } else {
        this.notification.error("Error while updating Budget Life, Please contact Tracktreads Support")
      }
    })
  }

  UpdateBudgetDistance(Id: number, BudgetDistance: number) {
    this._interp.UpdateBudgetDistance(Id, BudgetDistance, this.screenId).subscribe(res => {
      if (res) {
        this.notification.success("Budget Distance updated successfully")
      } else {
        this.notification.error("Error while updating Budget Distance, Please contact Tracktreads Support")
      }
    })
  }

  openTrackCofiguration(selectedType: number, selectedValue: number, systemId: number, Side: string) {
    const dialogRef = this._dialog.open(TrackFrameConfigurationComponent, {
      disableClose: true,
      width: '1032px',
      data: {
        selectedType: selectedType,
        selectedValue: selectedValue,
        systemId: systemId,
        equipmentId: 0,
        side: Side == 'Left' ? 1 : 2,
        screenId: this.screenId
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if (Side == "Left") {
        if (selectedType == 1)
          this.system.ToeOutFrame = res;
        if (selectedType == 2)
          this.system.CastFrame = res;
      }
      else {
        if (selectedType == 1)
          this.system.ToeOutFrame = res;
        if (selectedType == 2)
          this.system.CastFrame = res;
      }
      // this._equipmentService.getEquipmentSystems(this.equipmentId).subscribe(systems => {
      //     this.equipmentSystems = systems;
      // });
    });
  }

  updateSystemCondition(system: SystemsInInventoryViewModel, newValue: string) {
    if (!this.isAdministrator)
      return;
    this._interp.updateSystemCondition(system.SystemId, newValue).subscribe(r => {
      if (r.m_Item1) {
        system.SystemCondition = newValue;
        system.SystemConditionColor = r.m_Item2;
        this.notification.success("Frame Condition updated successfully")
      } else {
        this.notification.error("Error while updating Frame Condition, Please contact Tracktreads Support")
      }
    })
  }

  getSystemLife() {
    this._interp.getSystemLife(this.system.SystemId).subscribe(res => {
      this.system.LifeLived = res;
    })
  }

  getSystemDOC() {
    this._interp.getSystemDOC(this.system.SystemId).subscribe(res => {
      this.system.LifeLivedKm = res;
    })
  }

  loadUserJobRoles() {
    this._userService.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
        switch (r.Name) {
          case 'Inspectors':
            this.isAdministrator = true;
            break;
          case 'Undercarriage ONLY':
            this.isAdministrator = true;
            break;
          case 'Super User':
            this.isAdministrator = true;
            break;
          case 'Administrator':
            this.isAdministrator = true;
            break;
          case 'Customer Admin':
            this.isAdministrator = true;
            break;
        }
      });
    });
  }

  loadActionHistory(loadingPage: number, pageSize: number) {
      const ids = [
        this.system.SystemId
      ].filter(id => id != null); 
      const systemIds: string = ids.length ? ids.join(',') : '';
          this.loadingService.startLoading();
          this._wsreService.getActionHistory(systemIds, this.screenId, 3, loadingPage, pageSize).subscribe({
              next: res => {
                  this.auditTrailHistory = res.Data;
                  this.auditTrailTotalRecords = res.TotalRecords;
              },
              error: err => {
                  console.error('Failed to load history', err);
              },
              complete: () => {
                this.loadingService.finishedLoading();
              }
          });
      }
      pageChanged(event: PageEvent) {
        console.log(event);
        //this.loadActionHistory(event.pageIndex + 1, event.pageSize);
      }
  
    isImage(value: string | null | undefined): boolean {
      if (!value) return false;
      const lower = value.toLowerCase();
      return lower.endsWith('.png') ||
         lower.endsWith('.jpg') ||
         lower.endsWith('.jpeg') ||
         lower.endsWith('.ico');
    }

    openEditComponentPopup(component: SystemComponentViewModel) {
      const viewModalRef = this._dialog.open(ChangeComponentComponent, {
        width: '500px',
        data: {
          eQunitId: component.EqunitId,
          comparttype_auto: component.CompartType,
          compartid_auto: component.CompartId,
          shoeSizeId: component.ShoeSize ?? 0,
          shoeGrouserId: component.GrouserId ?? 0,
          cleanerHolesId: component.CleanerHolesId ?? 0,
          make: component.MakeId,
          budgetLife: component.Budget,
          masterLink: component.MLink,
          jobNumber: component.JobNumber,
          bushTurnedBudgetPer: component.BushTurnedPercent,
          assetNumber: component.AssetNumber,
          bushTurnedHour: component.BushTurnedBudgetLife,
          wornPercentage: component.WornPercentage,
          cmu: component.CMU,
          screenId: this.screenId
        }
      });
      viewModalRef.afterClosed().subscribe(result => {
        console.log("viewModalRef.afterClosed() result:", result);
        if (result) {
          this.loadHistoriesAndInfo();
        }
      });
    }

}
